<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
  [noSubmitBtn]="form.controls.type.value === null"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  @if (!entity.type) {
    <div
      class="form-step form-step-before"
      [ngClass]="{ left: form.controls.type.value != null }"
    >
      <h3 class="drawer-title">Produit défiscalisant</h3>
      <ul>
        @for (product of products; track product) {
          <li class="pointer choose-button" (click)="selectType(product.id)">
            {{ product.label }}
          </li>
        }
      </ul>
    </div>
  }
  <div
    class="form-step"
    [ngClass]="{ right: form.controls.type.value == null }"
  >
    <input formControlName="id" type="hidden" />

    <pr-tabs
      clazz="drawer-tab-button"
      [defaultTextColor]="false"
      [changeTab]="changeTab"
      (lastTab)="onTabChange($event)"
    >
      <pr-tab label="Informations Générales">
        <pr-input-autosuggest
          formControlName="contratId"
          label="Gestionnaire"
          [options]="managers"
          [derrors]="derrors"
          [optionLabel]="'name'"
        >
          <span customOptionText
            >Ce gestionnaire sera créé lors de l'enregistrement.</span
          >
        </pr-input-autosuggest>

        <pr-input [label]="'Nom de l’opération'" [derrors]="derrors">
          <input formControlName="label" type="text" />
        </pr-input>

        <pr-input
          [label]="'Montant investi'"
          [suffix]="'€'"
          [derrors]="derrors"
        >
          <input formControlName="purchasePrice" type="text" />
        </pr-input>

        @if (form.controls.type.value == 'GIRARDIN') {
          <pr-input
            [label]="'Taux de réduction'"
            [suffix]="'%'"
            [derrors]="derrors"
          >
            <input formControlName="girardinRate" type="text" />
          </pr-input>
        }

        @if (
          assetTypeService
            .getTaxExemptingAssetTypeFipFCPI()
            .includes(form.controls.type.value)
        ) {
          <pr-input
            [label]="'Taux de réduction'"
            [suffix]="'%'"
            [derrors]="derrors"
          >
            <input formControlName="taxReductionRate" type="text" />
          </pr-input>
        }

        @if (['SOFICA'].includes(form.controls.type.value)) {
          <pr-input label="Taux de réduction" [derrors]="derrors">
            <mat-select formControlName="taxReductionRate">
              @for (item of soficaDefiscalisations; track item) {
                <mat-option [value]="item.id">
                  {{ item.name }}
                </mat-option>
              }
            </mat-select>
          </pr-input>
        }

        <pr-input-date
          formControlName="startDate"
          label="Date d’acquisition"
          [derrors]="derrors"
        ></pr-input-date>
        <pr-input-date
          formControlName="endDate"
          label="Date de clôture"
          [derrors]="derrors"
        ></pr-input-date>
      </pr-tab>
      <pr-tab label="Détention">
        <pr-input label="Acquis au travers" [derrors]="derrors">
          <mat-select formControlName="source">
            @for (item of sources; track item) {
              <mat-option [value]="item.id">
                {{ item.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-owner-share
          formControlName="owners"
          [derrors]="derrors"
        ></pr-input-owner-share>
      </pr-tab>
    </pr-tabs>
  </div>
</pr-form>
